import { IDocumentos, IOCRResultParsed } from '@/interfaces'

export class OCRResultParsed implements IOCRResultParsed {
	nome: string | null
	cpf: string | null
	dataNascimento: string | null
	nomeMae: string | null
	nacionalidade: string | null
	documentoTipo: string | null
	documentoNumero: string | null
	documentoDataEmissao: string | null
	documentoOrgaoExpedidor: string | null
	documentoUF: string | null
	cep: string | null
	endereco: string | null
	enderecoNumero: string | null
	enderecoComplemento: string | null
	bairro: string | null
	cidade: string | null
	enderecoUF: string | null
	empresaNome: string | null
	profissao: string | null
	cargo: string | null
	dataAdmissao: string | null
	tipoContratacao: string | null
	rendaMensal: string | null
	documentosList: null | Array<IDocumentos.IFileCategorized>

	constructor(objeto: IOCRResultParsed) {
		this.nome = objeto.nome
		this.cpf = objeto.cpf
		this.dataNascimento = objeto.dataNascimento
		this.nomeMae = objeto.nomeMae
		this.nacionalidade = objeto.nacionalidade
		this.documentoTipo = objeto.documentoTipo
		this.documentoNumero = objeto.documentoNumero
		this.documentoDataEmissao = objeto.documentoDataEmissao
		this.documentoOrgaoExpedidor = objeto.documentoOrgaoExpedidor
		this.documentoUF = objeto.documentoUF
		this.cep = objeto.cep
		this.endereco = objeto.endereco
		this.enderecoNumero = objeto.enderecoNumero
		this.enderecoComplemento = objeto.enderecoComplemento
		this.bairro = objeto.bairro
		this.cidade = objeto.cidade
		this.enderecoUF = objeto.enderecoUF
		this.empresaNome = objeto.empresaNome
		this.profissao = objeto.profissao
		this.cargo = objeto.cargo
		this.dataAdmissao = objeto.dataAdmissao
		this.tipoContratacao = objeto.tipoContratacao
		this.rendaMensal = objeto.rendaMensal
		this.documentosList = objeto.documentosList
	}
}
